import React from 'react';
import type { ReactElement } from 'react';
import { BellFilledMd, BellMd, Button, paletteHelper, spacingHelper } from '@construct-kit/core';
import styled, { keyframes } from 'styled-components';

type SetAlertButtonProps = {
  onClick: () => void;
  alertSet: boolean;
  disabled?: boolean;
};

const StyledButton = styled(Button)`
  position: absolute;
  right: ${spacingHelper('twoExtraSmall')};
  bottom: ${spacingHelper('extraSmall')};

  :hover {
    background-color: transparent;
  }
`;

const ring = keyframes`
  25% {
    transform: scale(1.1) rotate(-5deg);
  }
  50% {
    transform: scale(1.2) rotate(10deg);
  }
  75% {
    transform: scale(1.1) rotate(-5deg);
  }
`;

const StyledBell = styled(BellFilledMd)`
  display: inline-block;
  color: ${paletteHelper('graphicYellow')};
  animation: ${ring} 0.7s ease-in-out backwards;
`;

const UNSUPPORTED_SEARCH_MESSAGE = 'Alerts are not available for this type of search';

const SetAlertButton = ({
  alertSet,
  onClick,
  disabled = false,
}: SetAlertButtonProps): ReactElement => (
  <StyledButton
    onClick={onClick}
    variant="naked"
    sizeVariant="small"
    icon={alertSet ? <StyledBell /> : <BellMd />}
    disabled={disabled}
    title={disabled ? UNSUPPORTED_SEARCH_MESSAGE : undefined}
  >
    {alertSet ? 'Alert set' : 'Set alert'}
  </StyledButton>
);

export default SetAlertButton;
